import { useState } from 'react';

export function useModal(
  opened = false
): [boolean, (callback?: () => void) => void, (callback?: () => void) => void] {
  const [modalOpened, setModalOpened] = useState(opened);

  function openModal(callback?: () => void) {
    setModalOpened(true);
    if (callback) {
      callback();
    }
  }

  function closeModal(callback?: () => void) {
    setModalOpened(false);
    if (callback) {
      callback();
    }
  }

  return [modalOpened, openModal, closeModal];
}
